import React, { useEffect, useState } from "react";
import { api } from "@/lib/http";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Linkify } from "@/components/Linkify";

const fmt = (d) => (d ? new Date(d).toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—");

export const formStatus = (c) => (c.status === "completed" ? { label: "Completed", cls: "bg-emerald-100 text-emerald-700" } : c.opened_at ? { label: "Opened · not completed", cls: "bg-amber-100 text-amber-700" } : { label: "Sent · not opened", cls: "bg-muted text-muted-foreground" });
export const aftercareStatus = (a) => (a.viewed_at ? { label: "Read", cls: "bg-emerald-100 text-emerald-700" } : { label: "Sent · not opened", cls: "bg-muted text-muted-foreground" });

// Read-only view of a submitted consultation form: every question with the client's answer.
export const FormAnswersDialog = ({ clientId, instanceId, onClose }) => {
  const [inst, setInst] = useState(null);
  useEffect(() => { if (instanceId) api.get(`/clients/${clientId}/consultations/${instanceId}`).then(({ data }) => setInst(data)).catch(() => setInst(null)); else setInst(null); }, [clientId, instanceId]);
  const ans = inst?.answers || {};
  const val = (el) => {
    if (el.type === "client_details") return [ans[`${el.id}_name`], ans[`${el.id}_email`], ans[`${el.id}_phone`]].filter(Boolean).join(" · ");
    const v = ans[el.id];
    if (v === true) return "Yes"; if (v === false || v == null || v === "") return "";
    return Array.isArray(v) ? v.join(", ") : String(v);
  };
  return (
    <Dialog open={!!instanceId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="form-answers">
        <DialogHeader><DialogTitle className="font-heading">{inst?.name || "Form"}</DialogTitle>
          {inst && <p className="text-xs text-muted-foreground">Sent {fmt(inst.sent_at)}{inst.opened_at ? ` · opened ${fmt(inst.opened_at)}` : ""}{inst.completed_at ? ` · completed ${fmt(inst.completed_at)}` : " · not completed"}</p>}</DialogHeader>
        {!inst ? <p className="text-sm text-muted-foreground">Loading…</p> : (
          <div className="space-y-3">
            {(inst.elements || []).filter((el) => el.type !== "text").map((el) => (
              el.type === "heading" ? <div key={el.id} className="font-heading font-semibold text-sm pt-2 border-b pb-1">{el.label}</div> : (
                <div key={el.id} className="grid grid-cols-[1fr_1.2fr] gap-3 text-sm" data-testid={`answer-${el.id}`}>
                  <div className="text-muted-foreground">{el.label}{el.required && <span className="text-destructive"> *</span>}</div>
                  <div className={`whitespace-pre-wrap ${val(el) ? "" : "text-muted-foreground/60 italic"}`}>{val(el) ? <Linkify text={val(el)} /> : (inst.status === "completed" ? "Left blank" : "Not answered yet")}</div>
                </div>
              )
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
